export default [

     {
          path: '/third-party-assessment',
          name: 'ThirdPartyAssessment',
          component: () => import("@/views/Page/ThirdPartyAssessment/ThirdPartyAssessment.vue"),
           meta: {
               title: 'ThirdPartyAssessment',
          },
     }
];